import { useBusinessContext } from '@context'
import {
  fetchFirstTransactionFetchNotice,
  FIRST_TRANSACTION_FETCH_STALE_MS,
  firstTransactionFetchQueryKey,
  FirstTransactionFetchNotice,
  IFirstTransactionFetch
} from '@query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

export const FIRST_TRANSACTION_FETCH_POLL_MS = 5000

const isAwaitingNotice = (notice?: FirstTransactionFetchNotice) =>
  notice === FirstTransactionFetchNotice.Fetching || notice === FirstTransactionFetchNotice.Delayed

export const useFirstTransactionFetchNotice = () => {
  const { slug } = useBusinessContext()
  const queryClient = useQueryClient()
  const queryKey = firstTransactionFetchQueryKey(slug)

  const query = useQuery({
    queryKey,
    queryFn: async () => {
      const previous = queryClient.getQueryData<IFirstTransactionFetch>(queryKey)
      const data = await fetchFirstTransactionFetchNotice({ slug })
      if (isAwaitingNotice(previous?.notice) && !isAwaitingNotice(data.notice)) {
        void queryClient.invalidateQueries({ queryKey: [slug, 'documents'] })
      }
      return data
    },
    staleTime: FIRST_TRANSACTION_FETCH_STALE_MS,
    refetchOnWindowFocus: false,
    refetchInterval: current =>
      isAwaitingNotice(current.state.data?.notice) ? FIRST_TRANSACTION_FETCH_POLL_MS : false
  })

  const notice = query.data?.notice ?? FirstTransactionFetchNotice.Idle

  return {
    notice,
    isAwaitingFirstFetch: isAwaitingNotice(notice)
  }
}
